const getDriveMetrics = state => state?.drives?.drivesMetrics
const getDriveRoleMetrics = state => state?.drives?.driveRolesMetrics
const getRoleMetrics = state => state?.drives?.roleMetrics
const getApplicantMetrics = state => state?.drives?.applicantMetrics
const getDriveData = state => state?.drives?.driveData
const getInterViewerList = state => state?.drives?.interViewerList
const getDriveInterViewerList = state => state?.drives?.driveInterViewerList
const getDegreeList = state => state?.drives?.degreeList
const getCollegeList = state => state?.drives?.collegeList
const getCandidateInterviewDetails = state =>
  state?.drives?.candidateInterviewDetails
const getGroupList = state => state?.drives?.groupList
const getGroupCandidateList = state => state?.drives?.groupCandidateList
const getCityList = state => state?.drives?.cityList
const getRoleRoundsList = state => state?.drives?.roleRoundList

const getRequestDocumentlist = state => state?.drives?.requestDocumentList
const getInterViewLocation = state => state?.drives?.interViewData
const getCandidateDocumentsMetrices = state =>
  state?.drives?.canditateDocumentMetrices
const getTopicList = state => state?.drives?.topicList

const selectors = {
  getDriveMetrics,
  getDriveRoleMetrics,
  getRoleMetrics,
  getApplicantMetrics,
  getDriveData,
  getInterViewerList,
  getInterViewLocation,
  getDriveInterViewerList,
  getDegreeList,
  getCollegeList,
  getCandidateInterviewDetails,
  getGroupList,
  getGroupCandidateList,
  getCityList,
  getRoleRoundsList,

  getRequestDocumentlist,
  getCandidateDocumentsMetrices,
  getTopicList,
}

export default selectors
